<!-- Main content -->
<section class="content">
  <div class="container-fluid">

    <div class="row">
      <div class="col-md-3">

        <!-- Profile Image -->
        <div class="card card-primary card-outline">

          <div class="card-body box-profile">            

            <h3 class="profile-username text-center">{{icd.Full_Legal_Company_Name}}</h3>

            <p class="text-muted text-center">{{icd.Owner_First_Name  + ' '+icd.Owner_Last_Name}}</p>

            <strong><i class="fas fa-map-marker-alt mr-1"></i> US or Canada</strong>

            <p class="text-muted">{{icd.US_or_CA}}</p>


            <hr>
            <strong><i class="fas fa-book mr-1"></i> F.E.I.N. # (Tax ID)/Business #</strong>

            <p class="text-muted">
              {{icd.Tax_ID}}
            </p>

            <hr>


            <strong><i class="fas fa-pencil-alt mr-1"></i> Campaign(s)</strong>

            <p class="text-muted">
              {{icd.Campaigns}}

            </p>

          </div>


          <!-- /.card-body -->
        </div>
        <!-- /.card -->
        <div class="card card-primary card-outline">
          <div class="card-body box-profile">

             
              <strong><i class="far fa-file-alt mr-1"></i> Legal Email</strong>

              <p class="text-muted">{{icd.Legal_Email}}</p>

              <hr>
               
              <strong><i class="far fa-file-alt mr-1"></i> Mobile Phone</strong>

              <p class="text-muted">{{icd.Mobile_Phone}}</p>

              <hr> 
            


             
          </div>


          <!-- /.card-body -->
        </div>
        <!-- /.card -->

        <!-- AI Case Summary -->
        <div class="card card-info card-outline">
          <div class="card-header py-2">
            <h3 class="card-title"><i class="fas fa-robot mr-1"></i> AI Summary</h3>
          </div>
          <div class="card-body p-3">
            <div *ngIf="summaryLoading" class="text-center text-muted py-1">
              <i class="fas fa-spinner fa-spin mr-1"></i> Generating summary&hellip;
            </div>
            <p *ngIf="!summaryLoading && caseSummary" class="text-muted small mb-0">{{caseSummary}}</p>
            <p *ngIf="!summaryLoading && !caseSummary" class="text-muted small mb-0">No summary available.</p>
          </div>
        </div>
        <!-- /.AI Summary card -->

      </div>
      <!-- /.col -->
      <div class="col-md-9">
        <div class="card card-primary card-outline card-outline-tabs">
          <div class="card-header p-0 border-bottom-0">
            <ul class="nav nav-tabs" id="custom-tabs-four-tab" role="tablist" *ngIf="isByaccount == 'No'">
              <!--<li class="nav-item detailmain" [class.active]="activeTab === 2">
                <a class="nav-link detailchild" (click)="activateTab(2)" routerLink="./icdinfo/{{id}}"
                   id="custom-tabs-four-home-tab" data-toggle="pill" href="#custom-tabs-four-home" role="tab" aria-controls="custom-tabs-four-home" aria-selected="true">ICD Information</a>
              </li>
              
              <li class="nav-item detailmain" [class.active]="activeTab === 3">
                <a class="nav-link detailchild" (click)="activateTab(3)" [routerLink]="['./offcamp', id]"
                   id="custom-tabs-four-profile-tab" data-toggle="pill" href="#custom-tabs-four-profile"
                   role="tab" aria-controls="custom-tabs-four-profile" aria-selected="false">Office & Campaign Details</a>
              </li>
              <li class="nav-item detailmain" [class.active]="activeTab === 4">
                <a class="nav-link detailchild" (click)="activateTab(4)" routerLink="./acknowledge/{{id}}" id="custom-tabs-four-messages-tab"
                   data-toggle="pill" href="#custom-tabs-four-messages" role="tab" aria-controls="custom-tabs-four-messages" aria-selected="false">Acknowledgement</a>
              </li>-->
              <!--<li class="nav-item detailmain" [class.active]="activeTab === 5">
      <a class="nav-link dropdown-toggle detailchild" (click)="activateTab(5)" routerLink="./icdmore" id="custom-tabs-four-settings-tab" data-toggle="pill" href="#custom-tabs-four-settings" role="tab" aria-controls="custom-tabs-four-settings" aria-selected="false">More</a>
    </li>-->
              <!--<li class="nav-item dropdown detailmain" [class.active]="activeTab === 5">
                <a class="nav-link dropdown-toggle" data-toggle="dropdown" id="custom-tabs-four-more-tab"> More </a>
                <ul class="dropdown-menu">
                  <li><a (click)="activateTab(5)" id="custom-tabs-add-loc" routerLink="./additional/{{id}}" class="dropdown-item detailchild"> Additional Location </a></li>

                  <li><a (click)="activateTab(6)" id="custom-tabs-camp-main" routerLink="./campmain/{{id}}" class="dropdown-item detailchild">  Campaign Maintenance</a></li>
                  <li><a (click)="activateTab(7)" id="custom-tabs-close-loc" routerLink="./closeloc/{{id}}" class="dropdown-item detailchild">  Close Location </a>

                  <li><a (click)="activateTab(8)" id="custom-tabs-change-off-info" routerLink="./changeoffinfo/{{id}}" class="dropdown-item detailchild"> Change Office Information  </a>

                  <li><a (click)="activateTab(9)" id="custom-tabs-close-icd" routerLink="./closeicd/{{id}}" class="dropdown-item detailchild"> Terminate Contract/ICD Closure  </a>

                  <li><a (click)="activateTab(10)" id="custom-tabs-move-loc" routerLink="./moveloc/{{id}}" class="dropdown-item detailchild">  Move Location </a>

                  <li><a (click)="activateTab(11)" id="custom-tabs-reopen-icd" routerLink="./reopenicd/{{id}}" class="dropdown-item detailchild"> Reopen ICD  </a>
                </ul>
              </li>-->

            </ul>

            <ul class="nav nav-tabs" id="custom-tabs-four-tab" role="tablist" *ngIf="isByaccount == 'Yes'">
             
             

            </ul>
          </div>
          <div class="card-body">
            <div class="tab-content" id="custom-tabs-four-tabContent">
              <router-outlet></router-outlet>
              
              
            </div>

          </div>
          <!-- /.card -->
        </div>
      </div>
       
        <!-- /.col -->
      </div>
    <!-- /.row -->
  </div><!-- /.container-fluid -->
</section>
<!-- /.content -->
<!-- /.content-wrapper -->
